import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowUpRight, Package } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { api } from "../lib/api";
import CartPill from "../components/CartPill";

export default function InkShopPage() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api
      .get("/ink-products")
      .then((r) => setItems(r.data))
      .catch(() => setErr("Couldn't load the shop right now — try again shortly."));
  }, []);

  return (
    <div className="min-h-screen bg-[var(--brand-bg,#F5F7FA)] text-[var(--brand-ink)]" data-testid="ink-shop-page">
      <Header />
      <main className="mx-auto max-w-6xl px-4 py-10">
        <div className="mb-8 flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="label-kicker text-[var(--brand-body)]">Merch · LAST original prints</p>
            <h1 className="mt-1 font-display text-4xl font-black tracking-tight sm:text-5xl">
              LAST Shop
            </h1>
            <p className="mt-3 max-w-2xl text-base text-[var(--brand-body)]">
              Original Coventry City fan gear, printed on demand by Inkthreadable
              in Blackburn and shipped direct to you. Every purchase helps keep
              this site running.
            </p>
          </div>
          <CartPill />
        </div>

        {err ? (
          <div className="mb-6 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="ink-shop-page-error">
            {err}
          </div>
        ) : null}

        {items === null ? (
          <div className="grid place-items-center py-20">
            <Loader2 className="h-6 w-6 animate-spin text-[var(--brand-body)]" />
          </div>
        ) : items.length === 0 ? (
          <div className="rounded-md border border-dashed border-black/20 bg-white p-10 text-center" data-testid="ink-shop-empty-public">
            <Package className="mx-auto h-8 w-8 text-[var(--brand-body)]" />
            <p className="mt-3 font-display text-lg font-bold">Products coming soon.</p>
            <p className="mt-1 text-sm text-[var(--brand-body)]">
              We&rsquo;re finalising the first LAST originals — check back in a few days.
            </p>
          </div>
        ) : (
          <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="ink-shop-grid">
            {items.map((p) => (
              <li key={p.id} data-testid={`ink-shop-tile-${p.id}`}>
                <Link
                  to={`/shop/${p.id}`}
                  className="card-hover group block overflow-hidden rounded-md border border-white bg-white"
                >
                  <div className="aspect-square w-full overflow-hidden bg-[#F8FAFC]">
                    {p.cover_image ? (
                      <img
                        src={p.cover_image}
                        alt=""
                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                      />
                    ) : null}
                  </div>
                  <div className="p-5">
                    <p className="font-display text-lg font-bold leading-tight">
                      {p.title}
                      {p.enquire_only ? (
                        <span
                          className="ml-2 inline-block rounded-sm bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800 align-middle"
                          data-testid={`ink-shop-tile-enquire-${p.id}`}
                        >
                          Enquire
                        </span>
                      ) : null}
                    </p>
                    <p className="mt-1 text-sm text-[var(--brand-body)]">
                      from £{Math.min(...p.variants.map((v) => v.price)).toFixed(2)}
                    </p>
                    <span className="mt-3 inline-flex items-center gap-1 font-display text-xs font-bold text-[var(--brand-ink)]">
                      View <ArrowUpRight size={12} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
      <Footer />
    </div>
  );
}
